import React, { Component } from 'react';
import { connect } from 'react-redux';
import { templatesDestinationsOperations } from 'state/templates/destinations';
import CountriesTemplateComponent from './CountriesTemplateComponent';

class CountriesTemplate extends Component {
  componentDidMount() {
    if (this.props.destinations.length === 0) {
      this.props.fetchDestinations();
    }
  }

  render() {
    const { content, destinations } = this.props;
    const displaySpinner = destinations.length === 0;
    const mapLocations = destinations.map((destination) => ({
      coordinates: destination.location.coordinates,
      label: destination.destinations.length,
    }));

    return (
      <CountriesTemplateComponent
        content={content}
        displaySpinner={displaySpinner}
        mapLocations={mapLocations}
        destinations={destinations}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    destinations: state.templates.destinations.destinations,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchDestinations() {
      dispatch(templatesDestinationsOperations.fetchDestinations());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CountriesTemplate);
